(function () {
  'use strict';
  var id = 'G-ST7322J3GJ';
  var host = window.location.hostname;
  if (!['zenvolto.com', 'www.zenvolto.com'].includes(host)) return;
  var query = new URLSearchParams(window.location.search);
  // Technical QA must never be counted as a customer session.
  if (query.has('zenvolto_qa') || query.has('preview_theme_id') || (window.Shopify && window.Shopify.designMode)) return;
  var initialized = false;
  var allowed = false;
  function permitted() {
    try { return !!(window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.analyticsProcessingAllowed()); }
    catch (_) { return false; }
  }
  function sync() {
    allowed = permitted();
    if (!allowed) {
      if (initialized) window.gtag('consent', 'update', {analytics_storage:'denied'});
      return;
    }
    if (initialized) { window.gtag('consent','update',{analytics_storage:'granted'}); return; }
    initialized = true;
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag('consent','default',{analytics_storage:'granted',ad_storage:'denied',ad_user_data:'denied',ad_personalization:'denied'});
    window.gtag('js',new Date());
    var referrer = '';
    try { var ref = new URL(document.referrer); referrer = ref.origin + ref.pathname; } catch (_) {}
    window.gtag('config',id,{send_page_view:false,allow_google_signals:false,allow_ad_personalization_signals:false,page_location:location.origin+location.pathname,page_referrer:referrer});
    window.gtag('event','page_view',{send_to:id,page_location:location.origin+location.pathname,page_referrer:referrer,page_title:document.title});
    var script = document.createElement('script'); script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id='+id;
    document.head.appendChild(script);
  }
  document.addEventListener('visitorConsentCollected',sync);
  if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}],function(error){if(!error)sync();});
  }
  document.addEventListener('click',function(event){
    var link=event.target.closest && event.target.closest('a.cg-product-link');
    if (!link || !initialized || !permitted()) return;
    var url; try {url=new URL(link.href);}catch(_){return;}
    var asin=link.getAttribute('data-affiliate-product');
    if (url.hostname!=='www.amazon.com' || !/^[A-Z0-9]{10}$/.test(asin) || url.pathname!=='/dp/'+asin) return;
    var card=link.closest('.cg-product');
    window.gtag('event','amazon_product_click',{send_to:id,product_asin:asin,product_name:card.querySelector('h3').textContent.trim(),placement:card.id,link_domain:'amazon.com',affiliate_tag:'mrbmtrchargers-20',transport_type:'beacon'});
  });
})();
